import React from 'react';
import { BadgeCheck, ShieldCheck, SearchCheck, Sparkles } from 'lucide-react';
import './QualityControl.css';

const standards = [
  {
    icon: ShieldCheck,
    title: 'Стандарты материалов',
    text: 'Используем сертифицированные составы и проверяем срок годности каждой партии перед работой.',
  },
  {
    icon: SearchCheck,
    title: 'Двойная приемка',
    text: 'Каждый этап проверяет мастер и старший смены: кузов, стыки, пластик, оптика и салон.',
  },
  {
    icon: BadgeCheck,
    title: 'Фотофиксация этапов',
    text: 'Фиксируем состояние автомобиля до и после работ, чтобы клиент видел прозрачный результат.',
  },
  {
    icon: Sparkles,
    title: 'Гарантия качества',
    text: 'Даем рекомендации по уходу и гарантийное сопровождение по выбранным услугам.',
  },
];

const process = [
  'Первичная диагностика и согласование задач',
  'Мойка и подготовка рабочей поверхности',
  'Выполнение работ по чек-листу сервиса',
  'Финишная проверка под направленным светом',
  'Передача авто с отчетом и рекомендациями',
];

const QualityControl = () => {
  return (
    <section className="quality-control">
      <div className="quality-control__inner">
        <div className="quality-control__hero">
          <p className="quality-control__eyebrow">Качество без компромиссов</p>
          <h1 className="quality-control__title">Контроль качества</h1>
          <p className="quality-control__description">
            Работаем по внутреннему регламенту детейлинга: от подготовки до финального осмотра автомобиля
            перед выдачей клиенту.
          </p>
        </div>

        <div className="quality-control__cards">
          {standards.map((standard) => {
            const Icon = standard.icon;
            return (
              <article key={standard.title} className="quality-control__card">
                <div className="quality-control__icon-wrap">
                  <Icon size={20} />
                </div>
                <h2>{standard.title}</h2>
                <p>{standard.text}</p>
              </article>
            );
          })}
        </div>

        <div className="quality-control__process">
          <h2>Как проходит проверка</h2>
          <ol>
            {process.map((step) => (
              <li key={step}>{step}</li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default QualityControl;
